import { cn, Icon, Input } from '@mntn/ui-components'
import { useEffect, useState } from 'react'
import { Button } from '@/components/shared'
import { useDebouncedCallback } from '@/hooks'

interface Props {
  // Search value from parent, used to initialize and reset the input
  searchValue: string
  setSearchValue: (searchValue: string) => void
  placeholder: string
  className?: string
  inputClassName?: string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const Search: React.FC<Props> = ({ searchValue, setSearchValue, placeholder, className, inputClassName }) => {
  const [inputValue, setInputValue] = useState(searchValue)
  const debouncedSearchChange = useDebouncedCallback(setSearchValue, 400)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    setInputValue(val)
    debouncedSearchChange(val)
  }

  const handleClear = () => {
    setInputValue('')
    setSearchValue('')
  }

  // Sync input value when parent resets search (e.g. clearing filters)
  useEffect(() => {
    setInputValue(searchValue)
  }, [searchValue])

  return (
    <Input
      iconLeft={<Icon name="Search" className="text-primary-inverse" />}
      iconRight={
        inputValue ? (
          <Button
            onClick={handleClear}
            aria-label="Clear search"
            size="tiny"
            variant="ghost"
            className="p-0 hover:bg-transparent"
          >
            <Icon name="X" className="size-4 text-primary-inverse" />
          </Button>
        ) : null
      }
      value={inputValue}
      onChange={handleChange}
      placeholder={placeholder}
      inputClassName={cn(
        'rounded-xs bg-surface-bg-inverse text-primary-inverse placeholder:text-primary-inverse border border-border h-auto focus:border-border hover:border-border',
        inputClassName,
      )}
      className={cn('min-w-[20rem]', className)}
    />
  )
}
